import moment from 'moment';
import { PagesRoutes } from '../../../../routing/PagesRoutes';
import { settings as shipmentSettingsModel } from '../../../../models/entities/shipment/shipment';
import StyledLink from '../../../shared/SmallComponents/StyledLink';
import { styled } from '../../../shared/Theme/theme';
import { ConsolidationDocumentRow } from './consolidationUtils';

type Props = {
    documents: ConsolidationDocumentRow[];
    settings?: shipmentSettingsModel;
};

const ConsolidationDocumentsTable = ({ documents, settings }: Props) => {
    const resolveTypeName = (typeCode?: string | string[]) => {
        const code = Array.isArray(typeCode) ? typeCode[0] : typeCode;
        if (!code) return '-';
        const match = settings?.documentTypes?.find((item) => item.code === code);
        return match?.name || code;
    };

    if (!documents.length) {
        return <EmptyMessage>No documents uploaded for shipments in this consolidation.</EmptyMessage>;
    }

    return (
        <TableWrap>
            <Table>
                <thead>
                    <tr>
                        <Th>Shipment</Th>
                        <Th>Type</Th>
                        <Th>File</Th>
                        <Th>Added by</Th>
                        <Th>Date</Th>
                        <Th>Last updated</Th>
                    </tr>
                </thead>
                <tbody>
                    {documents.map((doc) => (
                        <tr key={String(doc.id)}>
                            <Td>
                                <StyledLink to={`${PagesRoutes.Shipments}/${doc.shipmentId}`}>{doc.shipmentNumber}</StyledLink>
                            </Td>
                            <Td>{resolveTypeName(doc.type)}</Td>
                            <Td>{doc.fileName || '-'}</Td>
                            <Td>{doc.userName || '-'}</Td>
                            <Td>{doc.createdDate ? moment(doc.createdDate).format('DD/MM/YYYY') : '-'}</Td>
                            <Td>{doc.updatedAt ? moment(doc.updatedAt).format('DD/MM/YYYY HH:mm') : '-'}</Td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </TableWrap>
    );
};

const TableWrap = styled.div`
    width: 100%;
    overflow-x: auto;
    background: #fff;
    border-radius: 8px;
`;

const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    font-size: ${(props) => props.theme.fontSizes.gridCell};
    color: ${(props) => props.theme.colors.gridCell};
`;

const Th = styled.th`
    padding: 10px 12px;
    text-align: left;
    font-weight: 500;
    font-size: 13px;
    color: ${(props) => props.theme.colors.gridResultsCounter};
    background: #f5f6f8;
    border-top: 1px solid #e8e8e8;
    vertical-align: middle;
`;

const Td = styled.td`
    padding: 12px;
    text-align: left;
    vertical-align: middle;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

const EmptyMessage = styled.p`
    margin: 0;
    padding: 24px 12px;
    color: ${(props) => props.theme.colors.lightGray};
    font-size: ${(props) => props.theme.fontSizes.gridCell};
    background: #fff;
    border-radius: 8px;
`;

export default ConsolidationDocumentsTable;
